import { ContainerSteps } from './styles';

import { StepMfa } from '../StepMFA';
import { LoginPage } from '../StepLogin';
import { StepRedirect } from '../StepRedirect';
import { StepUnauthorized } from '../StepUnauthorized';
import { StepEsqueciSenha } from '../StepEsqueciSenha';
import { StepSelectCompany } from '../StepSelectCompany';
import { StepRecoverSuccess } from '../StepRecoverSuccess';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';
import { StepNoLinkedCompanies } from '../StepNoLinkedCompanies';

interface AuthSectionProps {
  isLoading: boolean;
  stepLogin: AuthSectionSteps;
  setIsLoading: (loading: boolean) => void;
  setStepLogin: (step: AuthSectionSteps) => void;
}

export function AuthSection({
  stepLogin,
  setStepLogin,
  isLoading,
  setIsLoading,
}: AuthSectionProps) {
  const getPaddingForContainer = () => {
    if (stepLogin === AuthSectionSteps.SELECT_COMPANY) {
      return '30px 50px';
    }
    return '50px';
  };

  const renderLoginSection = (stepLogin: AuthSectionSteps) => {
    switch (stepLogin) {
      case AuthSectionSteps.LOGIN:
        return (
          <LoginPage
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setStepLogin={setStepLogin}
          />
        );
      case AuthSectionSteps.AUTHENTICATION:
        return (
          <StepMfa setIsLoading={setIsLoading} setStepLogin={setStepLogin} />
        );
      case AuthSectionSteps.SELECT_COMPANY:
        return <StepSelectCompany />;
      case AuthSectionSteps.RECOVER_PASSWORD:
        return (
          <StepEsqueciSenha
            setIsLoading={setIsLoading}
            setStepLogin={setStepLogin}
          />
        );
      case AuthSectionSteps.RECOVER_PASSWORD_SUCCESS:
        return <StepRecoverSuccess setStepLogin={setStepLogin} />;
      case AuthSectionSteps.REDIRECT:
        return <StepRedirect setStepLogin={setStepLogin} />;
      case AuthSectionSteps.NO_LINKED_COMPANIES:
        return <StepNoLinkedCompanies setStepLogin={setStepLogin} />;
      case AuthSectionSteps.UNAUTHORIZED:
        return <StepUnauthorized setStepLogin={setStepLogin} />;
      default:
        return <StepRecoverSuccess setStepLogin={setStepLogin} />;
    }
  };

  return (
    <ContainerSteps sx={{ padding: getPaddingForContainer() }}>
      {renderLoginSection(stepLogin)}
    </ContainerSteps>
  );

  // return (
  //   <ContainerSteps sx={{ padding: getPaddingForContainer() }}>
  //     {stepLogin === AuthSectionSteps.LOGIN && (
  //       <LoginPage
  //         isLoading={isLoading}
  //         setIsLoading={setIsLoading}
  //         setStepLogin={setStepLogin}
  //       />
  //     )}
  //     {stepLogin === AuthSectionSteps.AUTHENTICATION && (
  //       <StepMfa setIsLoading={setIsLoading} setStepLogin={setStepLogin} />
  //     )}
  //     {stepLogin === AuthSectionSteps.SELECT_COMPANY && <StepSelectCompany />}
  //     {stepLogin === AuthSectionSteps.RECOVER_PASSWORD && (
  //       <StepEsqueciSenha
  //         setStepLogin={setStepLogin}
  //         setIsLoading={setIsLoading}
  //       />
  //     )}
  //     {stepLogin === AuthSectionSteps.RECOVER_PASSWORD_SUCCESS && (
  //       <StepRecoverSuccess setStepLogin={setStepLogin} />
  //     )}
  //     {stepLogin === AuthSectionSteps.REDIRECT && (
  //       <StepRedirect setStepLogin={setStepLogin} />
  //     )}
  //     {stepLogin === AuthSectionSteps.NO_LINKED_COMPANIES && (
  //       <StepNoLinkedCompanies setStepLogin={setStepLogin} />
  //     )}
  //     {stepLogin === AuthSectionSteps.UNAUTHORIZED && (
  //       <StepUnauthorized setStepLogin={setStepLogin} />
  //     )}
  //   </ContainerSteps>
  // );
}
